export default function actionListenersStoreEnhancer (createStore) {

  return (reducer, initialState, enhancer) => {

    const actionListeners = {}
    const store = createStore(reducer, initialState, enhancer)
    const dispatch = store.dispatch

    /**
     * Monkey-patch `store.dispatch`.
     * Dispatch the action as normal, store the result.
     * If action listeners exist for the action type, invoke each.
     * Return the result as normal.
     */
    store.dispatch = (action) => {
      const nextState = dispatch(action)

      if (typeof action === 'object' && action.type && actionListeners[action.type]) {
        actionListeners[action.type].forEach((listener) => listener(action))
      }

      return nextState
    }

    /**
     * Adds an API to the store to add listeners for an action type.
     */
    store.addActionListener = (actionType, listener) => {
      actionListeners[actionType] = (actionListeners[actionType] || []).concat(listener)
      return () => {
        actionListeners[actionType] = actionListeners[actionType].filter((l) => l !== listener)
      }
    }

    return store

  }

}
